import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import { AppStateModel } from './services/+redux/redux.models';

@Injectable()
export class AppRoleHeaderInterceptor implements HttpInterceptor {

  constructor(private store: Store) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if(this.store.selectSnapshot((state: AppStateModel) => this.getRoleIdFromState(state))){
        const newRequest = request.clone({
            headers: request.headers.set('RoleObjectId', this.store.selectSnapshot((state: AppStateModel) => this.getRoleIdFromState(state)))
        })
        
        return next.handle(newRequest);
    }
    else{
        return next.handle(request);
    }
  }

  private getRoleIdFromState(state: AppStateModel): string{
    return state.userState.user?.userContext?.roles?.find(r => r.value == state.roleState.currentRoleName)?.objectId;
  }

}
